import React, { useEffect, useState } from "react";
import coverRadar from "../../assets/images/site/blog-cover-radar.webp";
import coverLayers from "../../assets/images/site/blog-cover.webp";
import coverNetwork from "../../assets/images/site/blog-cover-red.webp";

const FALLBACK_COVERS = [coverRadar, coverLayers, coverNetwork];

/**
 * Imagen destacada de un post. Si el post no tiene imagen o la URL falla
 * (archivo borrado del media), se muestra una portada genérica de la marca
 * en vez de un hueco gris o el texto alternativo roto. `seed` (el id del
 * post) alterna entre varias portadas para que dos tarjetas vecinas sin
 * imagen no se vean iguales.
 */
function PostImage({ src, seed = 0, alt = "", className = "", ...props }) {
    const [failed, setFailed] = useState(false);
    useEffect(() => setFailed(false), [src]);
    const fallback = FALLBACK_COVERS[Math.abs(Number(seed) || 0) % FALLBACK_COVERS.length];
    const resolved = src && !failed ? src : fallback;

    return (
        <img
            src={resolved}
            alt={alt}
            className={className}
            loading="lazy"
            decoding="async"
            onError={() => setFailed(true)}
            {...props}
        />
    );
}

export default PostImage;
